// src/components/VehicleCalendar.js
import React, { useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import moment from "moment";

const VehicleCalendar = ({ availability }) => {
  // Set initial month to the current month (starting at its first day)
  const initialMonth = moment().startOf("month");
  const [currentMonth, setCurrentMonth] = useState(initialMonth);
  const today = moment().startOf("day");

  // Calculate number of days in the current month and generate an array for them.
  const daysInMonth = currentMonth.daysInMonth();
  const daysArray = Array.from({ length: daysInMonth }, (_, i) =>
    currentMonth.clone().date(i + 1)
  );

  // Determine if a day is booked using the aggregated availability field.
  const isBooked = (day) => {
    if (!availability || !availability.unavailableSlots) return false;
    return availability.unavailableSlots.some((slot) => {
      const slotStart = moment(slot.start);
      const slotEnd = moment(slot.end);
      // The day is booked if it falls on or between slotStart and slotEnd (inclusive)
      return day.isBetween(slotStart, slotEnd, "day", "[]");
    });
  };

  // Navigation handlers
  const handleNextMonth = () => {
    setCurrentMonth(currentMonth.clone().add(1, "month"));
  };

  const handlePrevMonth = () => {
    setCurrentMonth(currentMonth.clone().subtract(1, "month"));
  };

  return (
    <Box>
      {/* Header with navigation arrows */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <Typography variant="subtitle1" sx={{ flexGrow: 1, textAlign: "left" }}>
          Availability – {currentMonth.format("MMMM YYYY")}
        </Typography>
        {currentMonth.isAfter(initialMonth) && (
          <IconButton onClick={handlePrevMonth}>
            <ArrowBack />
          </IconButton>
        )}
        <IconButton onClick={handleNextMonth}>
          <ArrowForward />
        </IconButton>
      </Box>

      {/* Calendar Grid */}
      <Box display="flex" flexWrap="wrap">
        {daysArray.map((day) => {
          // Default color: available (green)
          let backgroundColor = "#8f8";
          // If day is in the past, show gray.
          if (day.isBefore(today, "day")) {
            backgroundColor = "#ccc";
          } else if (isBooked(day)) {
            backgroundColor = "#f88";
          }
          return (
            <Box
              key={day.format("YYYY-MM-DD")}
              sx={{
                width: 24,
                height: 24,
                m: 0.25,
                backgroundColor,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "0.7rem",
                color: "black",
              }}
              title={day.format("LL")}
            >
              {day.date()}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default VehicleCalendar;
